// eslint-disable-next-line @typescript-eslint/no-floating-promises -- fire-and-forget: top-level script IIFE
(async () => {
  try {
    const fs = require('fs').promises;

    const distIndexPath = './dist/index.js';
    const distTypesPath = './dist/types/index.d.ts';
    const loaderRelativePath = './loader/index.js';
    const loaderTypesRelativePath = '../loader/index.d.ts';

    // Idempotent (not atomic). Read the stencil-generated file, add the loader re-export only if it isn't
    // already present, and rewrite the whole file in a single writeFile. Read-modify-write across two
    // awaits is NOT atomic — concurrent writers could interleave — but package builds run sequentially,
    // so the guarantee we need is idempotency. The previous fs.appendFile lacked even that: a plain re-run
    // double-appended, and a partial append corrupted the shim (e.g. `export * from './esm/index.js';js';`).
    const ensureExport = async (filePath: string, relPath: string): Promise<void> => {
      const line = `export * from '${relPath}';`;
      const current = await fs.readFile(filePath, 'utf8');
      if (current.includes(line)) return;
      await fs.writeFile(filePath, `${current.trimEnd()}\n${line}\n`, 'utf8');
    };

    await ensureExport(distIndexPath, loaderRelativePath);
    console.warn(`Successfully ensured loader JavaScript exports in ${distIndexPath}`);

    await ensureExport(distTypesPath, loaderTypesRelativePath);
    console.warn(`Successfully ensured loader type exports in ${distTypesPath}`);

    const loaderRelativePackageJsonPath = './dist/loader/package.json';
    const customPackageJson = {
      name: 'capsule-loader',
      private: true,
      types: './index.d.ts',
      type: 'module',
      main: './index.js',
    };

    await fs.writeFile(loaderRelativePackageJsonPath, JSON.stringify(customPackageJson, null, 2));
    console.warn('Custom package.json written to loader directory.');
  } catch (error) {
    console.error('Error appending loader exports:', error);
    process.exit(1);
  }
})();
